<template>
    <app-wrapper>
        <app-header :loan="loan" medium-max-width="max-w-1000">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto">
                        Your loan application
                        <h2 class="mb-0 mt-2 md:mt-4 md:text-6xl">{{ loan.amount | money(0) }}</h2>
                    </div>
                    <div class="flex-initial">
                        <i class="fa fa-times-circle text-danger text-7xl"/>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #title>
                We're sorry, your loan application was not approved.
            </template>

            <template #text>
                <p class="mb-4">
                    Unfortunately, we were unable to approve your loan application at this time.
                </p>
                <p class="mb-4">
                    If you have any questions or need assistance, please <a href="/contact" target="_blank" class="text-black">contact us.</a>
                </p>
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
export default {
    mixins: [require('../../../mixins/InteractsWithGtag').default],

    props: ['loan'],

    data() {
        return {
            gTagPageName: 'introxl-rejected',
        }
    },

    created() {
        this.gTagEvent('introxl-rejected', {
            event_category: 'onboarding',
            event_label: 'introxl-rejected',
        });
    }
}
</script>